import AreaFeatureCardGridView from "@/components/areas/AreaFeatureCardGridView";

const AreaCourseFeatureListPage: React.FC = () => {

  return (
    <AreaFeatureCardGridView featureTypeSubType="Course" />
  );
};

export default AreaCourseFeatureListPage;
